/**
 * Apply any filter of the store and return the filtered products.
 * 
 * A filter could be the search input that exists in the toolbar,
 * if there is any input this getter will return only the products
 * that contains that input.
 */
function filteredProducts(state) {
  let products = state.products

  /* Check if there is any input of the searcher */
  const searchInput = state.searchInput
  const selectedFeature = state.selectedFeature
  if (searchInput && selectedFeature) {
    /* Filter the products that contains that word */
    products = products.filter(p => p.name.toLowerCase().includes(searchInput.toLowerCase()))
    /* Add the selected feature with the flag `notSaved: true` and `isFromSearch: true` */
    /* TODO: Handle this for future data like INFO and SPEC */
    products = products.map(product => {
      product = { ...product, taggedFeatures: [...product.taggedFeatures] }
      const alreadyHasTheTaggedFeature = product.taggedFeatures.some(({ featureId }) => {
        return featureId === selectedFeature.id
      })
      /* If it does not have already the feature add it with the flags */
      if (!alreadyHasTheTaggedFeature) {
        const offset = product.name.toLowerCase().indexOf(searchInput.toLowerCase())
        const value = product.name.slice(offset, offset + searchInput.length)
        product.taggedFeatures.push({
          dataId: product.nameId,
          featureId: state.selectedFeature.id,
          value,
          offset,
          notSaved: true,
          isFromSearch: true
        })
      }

      return product
    })
  }

  return products
}

export default {
  filteredProducts
}
